import api from '@/api';

import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { arrayToObject } from '@/utils/helpers';

import { SET_API_DOCS, ADD_API_DOC, UPDATE_API_DOC, DELETE_API_DOC } from './mutations';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const fetchAiAssistantApiDocs = buildActionObject('fetchAiAssistantApiDocs');
export const setAiAssistantApiDocs = buildActionObject('setAiAssistantApiDocs');
export const addAiAssistantApiDoc = buildActionObject('addAiAssistantApiDoc');
export const deleteAiAssistantApiDoc = buildActionObject('deleteAiAssistantApiDoc');
export const updateAiAssistantApiDoc = buildActionObject('updateAiAssistantApiDoc');
export const createAssistantThread = buildActionObject('createAssistantThread');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchAiAssistantApiDocs.action]({ dispatch }, { projectId }) {
		const apiDocs = await api.listAiAssistantApiDocs(projectId);
		const apiDocsObj = arrayToObject(apiDocs);
		await dispatch(setAiAssistantApiDocs.action, { apiDocs: apiDocsObj });
	},
	[setAiAssistantApiDocs.action]({ commit }, { apiDocs }) {
		commit(SET_API_DOCS, apiDocs);
	},
	async [addAiAssistantApiDoc.action]({ commit }, { apiDoc, project }) {
		const resp = await api.addAiAssistantApiDocs({ ...apiDoc, project });
		commit(ADD_API_DOC, resp);
		return resp;
	},
	async [updateAiAssistantApiDoc.action]({ commit }, { apiDoc }) {
		const aiDocPayload = { ...apiDoc };
		delete aiDocPayload.id;
		const resp = await api.updateAiAssistantApiDoc(apiDoc.id, aiDocPayload);
		commit(UPDATE_API_DOC, resp);
	},
	async [deleteAiAssistantApiDoc.action]({ commit }, { id }) {
		await api.deleteAiAssistantApiDoc(id);
		commit(DELETE_API_DOC, { id });
	},

	// eslint-disable-next-line no-empty-pattern
	async [createAssistantThread.action]({}, { nodeId }) {
		// This api is not actually related to the store or an api-doc but it is related to the assistant
		return await api.createAssistantThread(nodeId);
	},
};

export default actions;
